import React, { FC, useCallback, useMemo, useState } from 'react'

import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { toggleUpdateForeignProfileAction } from 'actions/foreignProfile/foreignProfileAction'
import { likePhotoNextProfilePlainAction } from 'actions/rating/likePhotoNextAction'
import { fetchUniNoticeAction } from 'actions/uninotice/uniNoticeAction'
import { Api6Error } from 'api/api.types'
import { useNavigateCoupleMatching } from 'components/block/Matching/hooks/useNavigateCoupleMatching'
import { ProfileMain } from 'components/block/Profile/ProfileMain/ProfileMain'
import { Routes } from 'components/block/Profile/ProfileMain/Routes'
import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { ContainerDesktopHeight } from 'components/designSystem/shared/containerDesktopHeight'
import {
  ratingVotingLimitExceededId,
  ratingVotingVipLimitExceeded,
} from 'components/uninotice/uniNoticeIdList'

import { mergePhotos } from './function/mergePhotos'
import { GQLForeignRootQuery } from './gql/__generated__/ForeignRoot'
import { RatingErrorLimit } from '../RatingWave/Rating.constants'

export const ForeignProfileNext: FC<{ data: GQLForeignRootQuery }> = ({
  data,
}) => {
  useNavigateCoupleMatching()

  const dispatch = useDispatch()

  const [loading, setLoading] = useState<boolean>(false)

  const handleClick = useCallback(async () => {
    if (data.user && data.user.photos.default && !loading) {
      setLoading(true)
      const { error } = (await dispatch(
        likePhotoNextProfilePlainAction(data.user.photos.default.photoId)
      )) as unknown as { error: Api6Error }

      if (error) {
        switch (error.code) {
          case RatingErrorLimit.limit:
            dispatch(
              fetchUniNoticeAction(ratingVotingLimitExceededId, {
                limit: error.data?.limit,
              })
            )
            break

          case RatingErrorLimit.vip_limit:
            dispatch(
              fetchUniNoticeAction(ratingVotingVipLimitExceeded, {
                limit: error.data?.limit,
              })
            )
            break

          default:
            console.error(`Profile like error ${error}`)
            break
        }
      } else {
        dispatch(toggleUpdateForeignProfileAction(true))
      }

      setLoading(false)
    }
  }, [data.user, dispatch, loading])

  const photos = useMemo(() => mergePhotos(data.user), [data.user])

  return (
    <Parent>
      <Body>
        <ProfileMain
          profile={data.user}
          photos={photos}
          enable={true}
          ui={data.ui}
          place="profile"
          onHandleClickControlButton={() => handleClick()}
        />
      </Body>
      <Routes />
    </Parent>
  )
}

const Parent = styled.div`
  display: flex;
  position: relative;
  flex-grow: 1;
`

const Body = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;

  @media (max-width: ${breakpoints.mobile}px) {
    height: 100%;
  }

  @media (min-width: ${breakpoints.mobile + 1}px) {
    max-height: calc(${ContainerDesktopHeight.tablet}px);
  }

  @media (min-width: ${breakpoints.middleDesktop}px) {
    max-height: calc(${ContainerDesktopHeight.middleDesktop}px);
  }

  @media (min-width: ${breakpoints.largeDesktop}px) {
    max-height: calc(${ContainerDesktopHeight.largeDesktop}px);
  }
`
